import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { PageLoader } from '@/components/shared/PageLoader';

const Inbox = lazy(() => import('@/pages/Inbox'));

export const Route = createFileRoute('/inbox')({
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <Inbox />
    </Suspense>
  ),
});
